import { useQuery } from '@tanstack/react-query';
import type { IUserCredentials } from '~/models/UserCredentials';
import { getOfficeCredentials } from '../clients/GetOfficeCredentials';
import { locationSettingsKeys } from './locationSettingsKeys';

/** One location's specialty, software and insurance. */
export const useOfficeCredentials = (officeId: string) =>
  useQuery<IUserCredentials>({
    queryKey: locationSettingsKeys.credentials(officeId),
    queryFn: () => getOfficeCredentials(officeId),
    enabled: !!officeId,
  });
